export const enum BusinessModelVariant {
    B2B = "B2B",
    B2C = "B2C",
    Both = "B2B_B2C",
}

export const enum WebsiteTypeVariant {
    ecommerce = "ecommerce",
    ecommerceDtc = "ecommerceDtc",
    ecommerceRetailer = "ecommerceRetailer",
    ecommerceOther = "ecommerceOther",
    publisher = "publisher",
    advertiser = "advertiser",
}

export const enum EmployeeHeadcountVariant {
    Range_0_10 = "range_0_10",
    Range_10_10 = "range_10_50",
    Range_50_200 = "range_50_200",
    Range_200_500 = "range_200_500",
    Range_500_1000 = "range_500_1000",
    Range_1000_5000 = "range_1000_5000",
    Range_5000_10000 = "range_5000_10000",
    Range_10000_plus = "range_10000_plus",
}

export enum CountryRadioEnum {
    specific = "specific",
    regions = "regions",
    worldwide = "worldwide",
}

export enum CountryRadioSelectorEnum {
    Specific = "specific",
    Worldwide = "worldwide",
}
